import { ReturnAssessmentWithDefinitionSchema } from "@redotech/redo-model/return-assessments/assessment-schemas";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getAssessmentList = {
  name: "getAssessmentList" as const,

  input: z.object({ kind: createEnum(ReturnTypeEnum).optional() }),

  output: z.array(ReturnAssessmentWithDefinitionSchema),
};
